import React from 'react';
import { Yes } from '../icons/Icons';

const PageResults = (props) => {

  return (
    <div className="kids-quiz__page">
      <div className="kids-quiz__question ui">
        <p className="question__title">{props.kidsName}, here is the product we recommend for you!</p>
        <p className="inline-results-p">{props.data.blend}</p>
        <div className="inline-results">
          <img src={props.data.blendImageUrl} />
          <ul>
            {props.data.blendHighlights.map((item, index) => (
              <li key={index}><Yes />{item}</li>
            ))}
          </ul>
        </div>
      </div>
      {props.retailStore === 'Brown Thomas' ?
        <a className="next-page next-page--show brown-thomas-button" href="https://www.brownthomas.com/search/?q=get+nourished&lang=en_IE">Back to Brown Thomas</a>
        : ''
      }
    </div>
  );
}

export default PageResults;